<template>
  <div class="trash-header container-fluid">
    <div class="row align-items-center justify-content-between">
      <div class="col-auto">
        <button class="btn back-button" @click="$router.back()" aria-label="Back">
          <i class="fa fa-arrow-left"></i>
        </button>
      </div>

      <div class="col text-center">
        <h2 class="page-title mb-0">Trash</h2>
        <p class="subtitle text-muted">Deleted projects and their archives</p>
      </div>

      <div class="col-auto"></div>
    </div>
  </div>

  <ReportTemplate :table-props="tableColumns" />
</template>

    
    <script>
    import "vue3-toastify/dist/index.css";
    import ReportTemplate from "../../components/ReportTemplate.vue";
    import {
        getSessionItem
    } from "@/store/session";
    
    import {
        type
    } from "../../utils/util";
    export default {
        name: "TrashView",
    data() {
        return {
            tableColumns: {
                        type: type.PROJECT,
                        isMultiSelectionAllowed: false,
                        filters: [{
                            isDeleted: true
                        }],
                        configs: [{
                            name: "remarks",
                            label: "Remarks",
                        order: 7,
                            isSortable: false,
                            textAlign: "left",
                        },
                        {
                            name: "accelatorStatus",
                            label: "Accelerator Status",
                                order: 5,
                            isSortable: false,
                                defaultSelected: true,
                            computedValue: "",
                            search: false,
                        },
                        {
                            name: "lastModifiedDate",
                            label: "Last Modified Date",
                                order: 6,
                            type: "date",
                        },
                        {
                            name: "status",
                            label: "Status",
                            order: 4,
                            defaultSelected: true,
                            isSortable: false,
                        },
                        {
                            name: "fileName",
                            label: "File Name",
                            order: 3,
                            defaultSelected: true,
                            checked: true,
                            textAlign: "left",
                        },
                        {
                            name: "requestDate",
                            label: "Request Date",
                            order: 1,
                            defaultSelected: true,
                            type: "date",
                        },
                        {
                            name: "projectId",
                            label: "Project ID",
                            order: 2,
                        },
                        ],
                        actions: {
                            restore: {
                                label: 'Restore'
                            }
                        },
                        },
            };
        },
        components: {
            ReportTemplate,
        },
        mounted() {
        },
        computed: {
        }
    };
    </script>
    
    <style scoped>
/* === Header Section === */
.trash-header {
  background: var(--body-bg);
  padding-top: 2px;
  transition: all 0.3s ease;
}

/* Title */
.page-title {
  font-weight: 600;
  color: var(--text-primary);
  font-size: 1.5rem;
  letter-spacing: -0.02em;
}

.subtitle {
  font-size: 0.9rem;
  margin: 0;
  color: var(--text-primary) !important;
}

/* Back Button */
.back-button {
  border: 1px solid var(--text-primary);
  color: var(--text-primary);
  width: 40px;
  height: 40px;
  border-radius: 50%;
  box-shadow: 0 2px 8px rgba(16, 24, 40, 0.1);
  transition: all 0.25s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.back-button:hover {
  transform: translateX(-3px);
  box-shadow: 0 4px 10px rgba(16, 24, 40, 0.15);
  color: var(--text-primary);
}

.back-button i {
  font-size: 18px;
}

/* Center alignment fix */
.row {
  align-items: center;
}

/* Responsive tweaks */
@media (max-width: 768px) {
  .page-title {
    font-size: 1.25rem;
  }

  .subtitle {
    font-size: 0.85rem;
  }
}
.trash-header {
  opacity: 0;
  transform: translateY(-10px);
  animation: fadeInHeader 0.4s ease-out forwards;
}

@keyframes fadeInHeader {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

    </style>
    
